<template>
<div class="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
  <div class="sm:mx-auto sm:w-full sm:max-w-md">
    <img class="mx-auto h-12 w-auto" src="https://res.cloudinary.com/dimona/image/upload/q_auto,f_auto/remote_media/assets/imgs/site/logo.png" />
    <h2 class="mt-6 text-center text-3xl leading-9 font-extrabold text-gray-900">
      Crie seu vídeo
    </h2>
  </div>

  <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
    <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
      <form action="#" method="POST">
        <div>
          <label for="nome" class="block text-sm font-medium leading-5 text-gray-700">
            Nome do seu amor
          </label>
          <div class="mt-1 rounded-md shadow-sm">
            <input id="nome" type="text" v-model="nome" required class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5" />
          </div>
        </div>

        <div class="mt-6">
          <label for="imagem" class="block text-sm font-medium leading-5 text-gray-700">
            Faça upload de uma foto de vocês
          </label>
          <filePicker @uploadFinished="handleUpload"></filePicker>
        </div>

        <div class="mt-6">
          <label for="country" class="block text-sm font-medium leading-5 text-gray-700">
            Para onde você quer levar essa pessoa?
          </label>
          <div class="mt-1 rounded-md shadow-sm">
            <select id="location1" v-model="location1" class="form-select block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5">
              <option value="videos:namorados_paris">Paris</option>
              <option value="videos:namorados_vegas">Las Vegas</option>
              <option value="videos:namorados_londres">Londres</option>
              <option value="videos:namorados_veneza">Veneza</option>
              <option value="videos:namorados_grecia">Grécia</option>
              <option value="videos:namorados_israel">Israel</option>
              <option value="videos:namorados_egito">Egito</option>
              <option value="videos:namorados_dubai">Dubai</option>
              
            </select>
          </div>
        </div>

        <div class="mt-6">
          <label for="country" class="block text-sm font-medium leading-5 text-gray-700">
            Para onde você quer levar essa pessoa?
          </label>
          <div class="mt-1 rounded-md shadow-sm">
            <select id="location2" v-model="location2" class="form-select block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5">
              <option value="videos:namorados_paris">Paris</option>
              <option value="videos:namorados_vegas">Las Vegas</option>
              <option value="videos:namorados_londres">Londres</option>
              <option value="videos:namorados_veneza">Veneza</option>
              <option value="videos:namorados_grecia">Grécia</option>
              <option value="videos:namorados_israel">Israel</option>
              <option value="videos:namorados_egito">Egito</option>
              <option value="videos:namorados_dubai">Dubai</option>
            </select>
          </div>
        </div>

        <div class="mt-6">
          <label for="country" class="block text-sm font-medium leading-5 text-gray-700">
            Para onde você quer levar essa pessoa?
          </label>
          <div class="mt-1 rounded-md shadow-sm">
            <select id="location3" v-model="location3" class="form-select block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5">
              <option value="videos:namorados_paris">Paris</option>
              <option value="videos:namorados_vegas">Las Vegas</option>
              <option value="videos:namorados_londres">Londres</option>
              <option value="videos:namorados_veneza">Veneza</option>
              <option value="videos:namorados_grecia">Grécia</option>
              <option value="videos:namorados_israel">Israel</option>
              <option value="videos:namorados_egito">Egito</option>
              <option value="videos:namorados_dubai">Dubai</option>
            </select>
          </div>
        </div>        

        <div class="mt-6">
          <span class="block w-full rounded-md shadow-sm">
            <button type="submit" @click.prevent="criarVideo" class="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-500 focus:outline-none focus:border-blue-700 focus:shadow-outline-blue active:bg-blue-700 transition duration-150 ease-in-out">
              Criar Vídeo
            </button>
          </span>
        </div>
      </form>
    </div>
  </div>


<!-- inicio modal -->
  <div class="fixed bottom-0 inset-x-0 px-4 pb-6 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center" v-if="modalOpen"> 
    <transition
      enter-active-class="ease-out duration-3000"
      enter-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="ease-in duration-2000"
      leave-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div class="fixed inset-0 transition-opacity" @click="modalOpen = false">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>
    </transition>
    <transition
      enter-active-class="ease-out duration-3000"
      enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      enter-to-class="opacity-100 translate-y-0 sm:scale-100"
      leave-active-class="ease-in duration-2000"
      leave-class="opacity-100 translate-y-0 sm:scale-100"
      leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    >
    <div class="bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-4xl sm:w-full sm:p-6">
      <div>

        <div class="mt-3 text-center sm:mt-5">
          <h3 class="text-lg leading-6 font-medium text-gray-900">
            <slot name="title">
              Feliz dia dos Namorados!
            </slot>
          </h3>
          <slot name="content">
            <div class="mt-2">
              <p class="text-sm leading-5 text-gray-500">
                  <!-- <a :href="url" target="_blank">Ver vídeo</a> -->
                  <video class="w-full" autoplay>
                    <source :src="url" type="video/mp4" @load="videoLoaded()">
                    Your browser does not support the video tag.
                  </video>
              </p>
            </div>
          </slot>
        </div>
      </div>
      <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
        <span class="flex w-full rounded-md shadow-sm sm:col-start-2">
          <slot name="saveButton">
            <button type="button" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-indigo-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo transition ease-in-out duration-150 sm:text-sm sm:leading-5">
              Compartilhar
            </button>
          </slot>
        </span>
        <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:col-start-1">
          <button type="button" @click="modalOpen = false" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline transition ease-in-out duration-150 sm:text-sm sm:leading-5">
            Fechar
          </button>
        </span>
      </div>
    </div>
    </transition>

  </div>
<!-- fim modal -->


</div>
</template>

<script src="https://cdn.jsdelivr.net/npm/lodash@4.13.1/lodash.min.js"></script>
<script>
import filePicker from './filePicker.vue'
export default {
  name: 'namorados',
  components: {
      filePicker
   },
  created: function() {
        
  },
  data() {
       return {
          modalOpen:false,
          nome:"",
          imagem:"",
          location1:"videos:namorados_veneza",
          location2:"videos:namorados_paris",
          location3:"videos:namorados_vegas",
          url:""
       }
     },
    mounted(){

    },
   methods:{
      criarVideo()
      {
        if(this.nome == ""){
          alert("Digite o nome");
          return;
        }
        if(this.imagem == ""){
          alert("Faça upload de uma foto");
          return;
        }
        var url = "https://res.cloudinary.com/dimona/video/upload/l_"+this.imagem+",so_75,eo_90,w_562,h_450,c_pad,b_auto:predominant,g_north,y_100,x_87/l_video:"+this.location3+",so_50,eo_70/l_video:"+this.location2+",so_30,eo_50/l_video:"+this.location1+",so_10,eo_30/e_colorize,co_white,l_text:verdana_100:"+this.nome+",x_215,y_380,so_0,eo_10/v1588781103/videos/namorados_base_inspiring";
        this.url = url;
        this.modalOpen = true;
      },
      canPlay(){
        console.log("rodei");
      },
      handleUpload : function(value){
            this.imagem = value;
        }
   }
}
</script>


// WEBPACK FOOTER //
// src/components/Home.vue